import '../sass/app.scss';
import Vue from 'vue/dist/vue.esm';
import "@babel/polyfill";
import interact from 'interactjs';

// Charger les fichiers javascripts globaux.
require('./bootstrap');

require('./garage-calendar/main');

require('./websocket');

Array.prototype.move = function(from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
};

window.L = function (key) {
  if (window.languageKeys[key] == undefined) {
    return "<span style='color: red'>" + key + "</span>";
  }
  return window.languageKeys[key];
}

// DÉFINIR LES COMPOSANTES ICI.
Vue.component('quote-detail-list', require('../components/QuoteDetailList.vue').default);
Vue.component('invoice-detail-list', require('../components/InvoiceDetailList.vue').default);
Vue.component('invoice-detail-list-form', require('../components/InvoiceDetailListForm.vue').default);
Vue.component('invoice-template-detail-list', require('../components/InvoiceTemplateDetailList.vue').default);
Vue.component('supplier-invoice-item-list', require('../components/SupplierInvoiceItemList.vue').default);
Vue.component('select-two-items', require('../components/Select2Items.vue').default);
Vue.component('select-two-suppliers', require('../components/Select2Suppliers.vue').default);
Vue.component('simple-listing', require('../components/SimpleListing.vue').default);
Vue.component('inspection-form', require('../components/InspectionForm.vue').default);
Vue.component('document-manager', require('../components/DocumentManager.vue').default);

Vue.mixin({
  methods: {
    L: str => window.L(str),
    __: str => window.L(str)
  }
})

window.Vue = Vue;

const supplierInvoiceScan = require('./rapidSupplierInvoiceModal');
window.openRapidSupplierInvoiceModal = supplierInvoiceScan.openRapidSupplierInvoiceModal;
window.quickImportSupplierInvoice = supplierInvoiceScan.quickImportSupplierInvoice;
window.refreshVue = function (selector) {

  $(selector).find(".vue-enabled").each(function () {
    var vm = new Vue({
      el: this
    });
  })

}

$(function () {
  refreshVue("body");
});

let modalRects = {}

let sizeRestriction = interact.modifiers.restrictSize({
  min: { width: 600, height: 300 },
  max: { width: 1200, height: 900 }
})

interact(".modal-content").draggable({
  allowFrom: ".modal-header",
  listeners: {
    move(event) {
      let target = event.target;
      
      if(!target.classList.contains("interact-inited")){
        let rects = target.getClientRects()[0];
        modalRects[target] = [0,0,rects.width,rects.height-121];
        target.classList.add("interact-inited")
      }

      modalRects[target][0] += event.dx
      modalRects[target][1] += event.dy;

      target.style.left = `${modalRects[target][0]}px`
      target.style.top = `${modalRects[target][1]}px`
    }
  }
}).resizable({
  edges: {
    bottom: true,
    top: true,
    left: true,
    right: true,
  },
  modifiers: [sizeRestriction],
  listeners: {
    move(event) {
      let target = event.target;

      if(!target.classList.contains("interact-inited")){
        let rects = target.getClientRects()[0];
        modalRects[target] = [0,0,rects.width,rects.height-121];
        target.classList.add("interact-inited")
      }

      if(event.edges.top){
        let dy = event.deltaRect.top;
        modalRects[target][1] += dy;
        modalRects[target][3] -= dy;
      }

      if(event.edges.left){
        let dx = event.deltaRect.left;
        modalRects[target][2] -= dx*2;
      }

      if(event.edges.bottom){
        let dy = event.deltaRect.bottom;
        modalRects[target][3] += dy;
      }

      if(event.edges.right){
        let dx = event.deltaRect.right;
        modalRects[target][2] += dx*2;
      }

      let modalBody = target.querySelector(".modal-body");
      let modalDialog = target.parentNode;
      
      target.style.left = `${modalRects[target][0]}px`
      target.style.top = `${modalRects[target][1]}px`
      modalDialog.style.width = `${modalRects[target][2]}px`
      modalBody.style.height = `${modalRects[target][3]}px`

    }
  }
})